<template>
	<div class="evaluation-layout">
        <!-- Loading -->
        <v-card v-if="loading" height="81vh" elevation="0" color="transparent"  class="d-flex flex-column justify-space-between align-center" >
            <v-row>
                <v-col align-self="center">
                    <v-progress-circular
                        size="50"
                        indeterminate
                        color="white"
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </v-card>

        <v-row justify="center" align="center" v-if="errorMessage">
            <v-col cols="12"  class="pt-9 white--text">
                {{errorMessage}}
            </v-col>
        </v-row>

        <!-- survey -->
        <div class="evaluation-layout-container" v-if="!loading && !errorMessage" >
            <v-form ref="form" @submit.prevent="save">
                <v-row justify="center" >
                    <v-col class="text-center ">
                        <div class="font-weight-bold body-1 mb-1">
                            Evaluación de desempeño
                        </div>
                    </v-col>
                </v-row>
                <div class="evaluation-layout-subtext mb-1 mb-sm-2 ">
                    Hola {{evaluatorName}}, en este ejercicio evaluarás el desempeño del compañero {{evaluatedName}}, quien colabora
                    como {{position}} en {{business}}, el periodo a evaluar es el {{periodicity}} comprendido {{period}}
                </div>
                <div class="evaluation-layout-instructions-text mb-4">
                    <span>
                        Selecciona una opción de cada uno de los siguientes aspectos sobre el desempeño del colaborador de acuerdo a tu criterio
                    </span>
                </div>

               
                
                <Form
                    :values="form"
                    :serverErrors="serverErrors"
                    
                    :questions="questions"
                ></Form>
            </v-form>
            

            <v-row justify="center" align="end" >
				<v-col cols="12" :class="$vuetify.breakpoint.xs ? 'pt-2' : 'pt-9'">
                    <p class="evaluation-layout-doc-rev pb-0 mb-2 ml-1 d-sm-none">{{docRev}}</p>
                    <v-row :justify="$vuetify.breakpoint.xs ? 'end' : 'space-between'" class="px-3 py-3">
                        <span class="evaluation-layout-doc-rev d-sm-flex d-none">{{docRev}}</span>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </div>
        <div class="evaluation-layout-footer" v-if="!loading">
            <app-footer class="mt-5 "></app-footer>

        </div>
	</div>
</template>

<script>
import AppFooter from "../components/AppFooter.vue";
import Form from "../views/managerViews/evaluations/EvaluationForm.vue";
import Utils from '../helpers/Utils';
// import VueGatesPlugin from '../plugins/vue-gates';
	export default {
		name: 'evaluation-layout',
		components: {
            AppFooter,
            Form
		},
        data() {
            return {
                docRev: 'GM-CLF-04 REV:04',
                errorMessage: null,
                evaluatorName: "",
                evaluatedName: "",
                position: "",
                business: "",
                periodicity: "",
                period: "",
                questions:[],
                formKey:83,
                icon:"",
                evaluationId: this.$route.params.evaluationId,
                employeeId: this.$route.params.employeeId,
                token: this.$route.params.token,
                employeeName: "あ",
                employeeNumber: "え",
                employeeCompany: "い",
                loading:true,
               
                serverErrors:{},
                form:{
                    answers: [ 
                        {
                            question_id: 1,
                            answer: 0
                        },
                        {
                            question_id: 2,
                            answer: 0
                        },
                        {
                            question_id: 3,
                            answer: 0
                        },
                        {
                            question_id: 4,
                            answer: 0
                        },
                        {
                            question_id: 5,
                            answer: 0
                        },
                        {
                            question_id: 6,
                            answer: 0
                        }
                    ],
                    comments: ''
                },

                rules: {
                    required: [
                        v => {
                            if(v == null || v == undefined)
                                return "Campo requerido";
                            try {
                                if(v.trim() == "")
                                    return "Campo requerido";
                            } catch (error) {
                                console.log(error);
                            }
                            return true;
                        }
                    ],
                },
                saveBtnData: {
                    text: "Enviar mis respuestas",
                    icon: "mdi-send-outline",	
                    click: this.save,
                    block:true,
                    loading: false,
                },
                
            }
        },
        computed: {
            // routeName: {
            //     get: function() {
            //         if(this.$route.name != 'Login')
            //             return true;
            //         return false;
            //     }
               
            // },
            
        
        },
        mounted(){

           

            window.addEventListener('resize', this.onResize, { passive: true });
            this.onResize();
           
            // this.$store.state.layout = 'Evaluation';

           

            setTimeout(() => {
                this.evaluationId = this.$route.params.evaluationId;
                this.employeeId = this.$route.params.employeeId;
                this.token = this.$route.params.token;
                this.index();
            }, 2000);
        },
        methods: {
           
            validate () {
                const status = this.checkManualValidatios();
                // this.$refs.form.validate();
                // this.$nextTick(() => {
                //  this.formKey = this.formKey + 1;
                // });
                return status;
            },
            checkManualValidatios(){
                let valid = true;

                this.form.answers.forEach(answ => {
                    if(answ.answer == undefined || answ.answer == null || answ.answer == '' || answ.answer == 0)
                        valid = false;
                });
                
                // 
                //
                // this.formKey++;
                return valid;
            },
            onResize () {
            
                if(window.innerWidth < 600){
                    this.saveBtnData.block = true;
                }
                else{
                    this.saveBtnData.block = false;
                }
            },
           
            setForm(data){
                this.evaluatorName = data.evaluator.name;
                const evaluatedData = data.evaluated.find((x) => x.employee.id.toString() == this.$route.params.employeeId);
                console.log(evaluatedData, "eva data")
                if(evaluatedData.answers != null){
                    console.log("ENTRAAAAA")
                    this.$router.push({name: 'EvaluationsAlreadyDone'});
                    // this.$router.push({name: 'EvaluationsThanks'});
                    // window.location.reload();
                    return;
                }
                this.evaluatedName = evaluatedData.employee.name;
                try {
                    this.position = evaluatedData.employee.current_contract.position.name;
                    this.business = evaluatedData.employee.current_contract.position.company.name;
                } catch (error) {
                    this.errorMessage = "El colaborador no tiene un puesto asignado";

                    return;
                }
                

                this.periodicity = this.getPeriodocity(data.periodicity);
                this.period = this.getPeriod(data);

                this.questions = data.questions.map((x) => {
                    x.question = x.question.replaceAll("*","");
                    x.options = x.options.map((x) => {
                        x.selected = false;
                        return x
                    })
                    return x;
                });
            },
            getPeriodocity(value)
            {

                switch (value) {
                    case 'MENSUAL':
                        return 'Mes';
                    case 'BIMESTRAL':
                        return 'Bimestre';
                    case 'TRIMESTRAL':
                        return 'Trimestre';
                    case 'SEMESTRAL':
                        return 'Semestre';
                    case 'ANUAL':
                        return 'Año';
                    default:
                        return '-'
                }
            },
            getPeriod(data)
            {
                switch (data.periodicity) {
                    case 'MENSUAL':
                        return `de ${data.period}`;
                    case 'BIMESTRAL':
                    case 'TRIMESTRAL':
                    case 'SEMESTRAL':
                    case 'ANUAL':
                        return `entre ${data.period}`;
                    default:
                        return '-'
                }
            },
            

            index(){
                if(this.$route.params.evaluationId == undefined || this.$route.params.evaluationId == '')
                    return;
                if(this.$route.params.token == undefined || this.$route.params.token == '')
                    return;

                //this.$store.state.overlay = true
                this.loading = true;
              
                console.log(this.evaluationId, "id", this.$route)
                this.$api.evaluation.getWithToken(this.$route.params.evaluationId, this.$route.params.token)
                .then((response) => {


                    this.setForm(response.data);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    
                    // this.$refs.form.reset();
                })
                
                
            },

            save(){
                this.saveBtnData.loading = true;
                // console.log(this.prepareRequest(this.form), "formmmm");
                if(this.validate()){
                    let request = this.prepareRequest(this.form);
                    // let response = {};
                    // response = this.$api.evaluation.storeAnswer(this.evaluationId, this.employeeId, request)
                    // let form = JSON.parse(JSON.stringify(this.form))
                   
                    this.$api.evaluation.storeAnswerWithToken(this.evaluationId, this.employeeId, this.token, request)
                        .then(() => {
                            // this.$router.push({name: 'Questionary'});
                            this.$router.push({name: 'EvaluationsThanks'});
                        })
                        .catch((error) => {
                            console.log(error.response)
                            var errors = []
                            switch(error.response.status){
                                case 400: 
                                    //console.log(99, error.response);
                                    if(("message" in error.response.data)){
                                        Object.keys(error.response.data.message).forEach((x) => {
                                            //console.log(x);
                                            // for (const [key, value] of Object.entries(object1)) {
                                            //     console.log(`${key}: ${value}`);
                                            // }
                                            this.serverErrors = error.response.data.message;
                                            const keyValue = x.split(".")
                                            error.response.data.message[x].forEach((y) => {
                                                this.serverErrors[`q_${keyValue[1]}`] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                        this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                    }
                                
                                break;
                            
                            }

                            console.log(this.serverErrors)
                        
                        })
                        .finally(() => {
                            this.saveBtnData.loading = false;
                        })
                    ;
                }else{
                    this.saveBtnData.loading = false;
                    this.$store.dispatch('snackbarError', `Formulario inválido`);
                   
                }
            },

            prepareRequest(request){
                let data = JSON.parse(JSON.stringify(request));

                

                return data;
            }
        },
	}
</script>

<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
    
    .evaluation-layout{
        background-color: #18585B;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        padding: 3rem 0px;
        
        &-container{
            background-color: white;
            width: 85%;
            padding: 2rem 7rem;

            @media (max-width: #{map-get($grid-breakpoints, 'xl')}) {
                padding: 2rem 5.5rem;
                
            }

            @media (max-width: #{map-get($grid-breakpoints, 'lg')}) {
                padding: 2rem 2rem;
                
            }

            @media (max-width: #{map-get($grid-breakpoints, 'md')}) {
                padding: 2rem 1rem;
                width: 95%;
                
            }
        }


        &-subtext{
            font-size: 0.85rem;
            font-weight: 500;
            line-height: 1rem !important;
        }

         &-instructions-text{
            font-size: 0.85rem;
            
        }

        &-form-input{
            label{
                font-size: .8rem !important;
            }
        }

        &-footer{
            align-self: flex-start;
            width: 85%;
            padding: 0rem 8rem ;
            .footer-text{
                color: white !important;
            }
            .footer-icon{
                // width: 200px;
                // height: 200px;
                filter: invert(100%) sepia(10%) saturate(7459%) hue-rotate(279deg) brightness(118%) contrast(108%);
            }
            @media (max-width: #{map-get($grid-breakpoints, 'xl')}) {
                padding: 0rem 7rem;
                
            }

            @media (max-width: #{map-get($grid-breakpoints, 'lg')}) {
                padding: 0rem 5rem;
                
            }

            @media (max-width: #{map-get($grid-breakpoints, 'md')}) {
                padding: 0rem 1rem;
                width: 95%;
                
            }


            
        }

        &-doc-rev{
            font-size: small;
            color: gray;
            font-weight: 600;
        }
       
        
    }
	
</style>